<template>
  <div class="notification-icon">
    <el-badge :value="unreadCount" :hidden="unreadCount === 0" class="notification-badge">
      <el-button class="notification-btn" :icon="Bell" circle @click="navigateToNotifications" />
    </el-badge>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { Bell } from '@element-plus/icons-vue';
import { useNotificationStore } from '@/store/notification';
import { useRouter } from 'vue-router';

const router = useRouter();
const store = useNotificationStore();
const unreadCount = computed(() => store.unreadCount);

const navigateToNotifications = () => {
  router.push('/notifications');
};

onMounted(() => {
  // 初始化时获取未读消息数量
  store.fetchNotifications('unread');
});
</script>

<style scoped>
.notification-icon {
  display: flex;
  align-items: center;
}

.notification-badge :deep(.el-badge__content) {
  z-index: 1;
}

.notification-btn {
  font-size: 24px;
  color: #606266;
  background: transparent;
  border: none;
  padding: 10px;
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.notification-btn:hover {
  background-color: #f5f7fa;
  transform: scale(1.05);
}

:deep(.el-badge__content.is-fixed) {
  top: 8px;
  right: 8px;
}
</style> 